import * as z from 'zod'
import type { TemuProducttypeCategoryRow } from '@/api/temuProducttypes/types'

export const temuProducttypeCategoryRowSchema: z.ZodType<TemuProducttypeCategoryRow> = z.object({
  producttypeKey: z.string(),
  categoryId: z.number().int(),
  categoryName: z.string().nullable(),
  producttype: z.object({
    producttypeName: z.string(),
  }),
})

export const temuProducttypeCategoryRowsSchema: z.ZodType<readonly TemuProducttypeCategoryRow[]> =
  z.array(temuProducttypeCategoryRowSchema)
